import { Col, Row, Tile, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { StyledCol } from './DocumentList.styles';
import { DocumentsState } from '../../../interfaces/DocumentsState';
import DocumentListGroup from './DocumentListGroup';
import SearchDocuments from './SearchDocuments';
import NoResults from './NoResults';
import NoDocuments from './NoDocuments';

export interface DocumentListProps { }

const DocumentList: FC<DocumentListProps> = () => {
  const groups = useScopedSelector((state: DocumentsState) => state.groups);

  if (!groups?.length) return (<NoDocuments />);

  return (
    <Row gutter={16}>
      <StyledCol xs={12} lg={8} m-t-xs={16} m-t-lg={0}>
        <Tile data-testid="documentTile" isDivided={false}>
          <NoResults />
          {groups.map((group) => <DocumentListGroup key={group.period} group={group} groups={groups}></DocumentListGroup>)}
        </Tile>
      </StyledCol>
      <Col xs={12} lg={4}>
        <SearchDocuments />
      </Col>
    </Row>
  );
};

export default DocumentList;
